import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon, CheckIcon } from "lucide-react";
import { comparisonRows } from "../data/landing";
import { SegmentedControl } from "./SegmentedControl";
type Mode = "sin" | "con";
export function Comparison() {
  const [mode, setMode] = useState<Mode>("sin");
  const isCon = mode === "con";
  return <section className="bg-paper" data-id="element-53" data-mp="1ux7da7bxduni">
      <div className="mx-auto max-w-5xl px-5 py-12 md:px-8 md:py-24" data-id="element-54" data-mp="1uw5qx6pgllqh">
        <div className="text-center" data-id="element-55" data-mp="1zw1whadt1l85">
          <p className="text-sm font-semibold text-wine" data-id="element-56" data-mp="1zuz3mwwx98pl">La realidad</p>
          <h2 className="mt-2 font-display text-[28px] text-forest md:mt-3 md:text-5xl" data-id="element-57" data-mp="23xdkjbh15ye8">¿Cuánto cuesta NO tenerlo?</h2>
        </div>
        {/* Mobile: interactive toggle */}
        <div className="mt-6 md:hidden" data-id="element-58" data-mp="9jvy5rsd37ks">
          <SegmentedControl<Mode> label="Comparar" value={mode} onChange={setMode} options={[{
          value: "sin",
          label: "Sin el Megapack"
        }, {
          value: "con",
          label: "Con el Megapack"
        }]} data-id="element-59" data-mp="9kxkisetvght" />
          <p className="mt-2 text-center text-xs text-muted" data-id="element-60" data-mp="1h9qsb1grfz70">{isCon ? "Así se ven tus fiestas ahora" : "Tocá “Con el Megapack” para ver la diferencia"}</p>
          <div className={`mt-4 overflow-hidden rounded-2xl transition-colors duration-200 ${isCon ? "bg-[#EEF1EA]" : "bg-cream"}`} data-id="element-61" data-mp="1d6ava40s3wts">
            <AnimatePresence mode="wait" initial={false} data-id="element-62" data-mp="25038t0q2n497">
              <motion.ul key={mode} initial={{
              opacity: 0,
              x: isCon ? 12 : -12
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: isCon ? -12 : 12
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} className="divide-y divide-line" data-id="element-63" data-mp="24xh213b08ss1">
                {comparisonRows.map(r => <li key={r.without} className={`flex gap-2.5 px-4 py-3 text-sm ${isCon ? "font-medium text-forest" : "text-muted"}`} data-id="element-64" data-mp="khdhad3lom6u">
                    {isCon ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden data-id="element-65" data-mp="h2bzcosxshjp" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine" aria-hidden data-id="element-66" data-mp="lysw27e7c48e" />}
                    {isCon ? r.with : r.without}
                  </li>)}
              </motion.ul>
            </AnimatePresence>
          </div>
        </div>
        {/* Desktop: table */}
        <div className="mt-12 hidden overflow-hidden rounded-2xl ring-1 ring-line md:block" data-id="element-67" data-mp="3uevx3uat6unr">
          <table className="w-full text-left text-[15px]" data-id="element-68" data-mp="33vtt16t8x35">
            <thead data-id="element-69" data-mp="3lhbpm3mcs24p">
              <tr data-id="element-70" data-mp="3lhv9hpvkd0ld">
                <th scope="col" className="w-1/2 bg-cream px-7 py-4 font-display text-xl font-normal text-muted" data-id="element-71" data-mp="3le7fkpm7ic64">
                  Sin el Megapack
                </th>
                <th scope="col" className="w-1/2 bg-forest px-7 py-4 font-display text-xl font-normal text-paper" data-id="element-72" data-mp="3bicrvg34lqwh">
                  Con el Megapack
                </th>
              </tr>
            </thead>
            <tbody data-id="element-73" data-mp="2wve1zpjx34jv">
              {comparisonRows.map(r => <tr key={r.without} className="border-t border-line" data-id="element-74" data-mp="2rx47zi9xi9zu">
                  <td className="bg-paper px-7 py-4 align-top text-muted" data-id="element-75" data-mp="36t208pgqeu6s">
                    <span className="flex gap-2.5" data-id="element-76" data-mp="36qyyx9a4pemr">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine" aria-hidden data-id="element-77" data-mp="31t76me5knqi1" />
                      {r.without}
                    </span>
                  </td>
                  <td className="bg-[#EEF1EA] px-7 py-4 align-top font-medium text-forest" data-id="element-78" data-mp="3av6n95cocskg">
                    <span className="flex gap-2.5" data-id="element-79" data-mp="3pjjp2iyg15mv">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden data-id="element-80" data-mp="3pj9yat5kqug4" />
                      {r.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}